import { loginRequest, loginSuccess, loginFailure } from '../actions/authActions';

const initialState = {
    accessToken: null,
    refreshToken: null,
    userData: null,
    loading: false,
    error: null,
};

const authReducer = (state = initialState, action) => {
    switch (action.type) {
        case 'LOGIN_REQUEST':
            return { ...state, loading: true };
        
        case 'LOGIN_SUCCESS':
            return {
                ...state,
                accessToken: action.payload.accessToken,
                refreshToken: action.payload.refreshToken,
                userData: action.payload.userData,
                loading: false,

            };
        
        case 'LOGIN_FAILURE':
            return {
                ...state,
                error: action.payload,
                loading: false,

            };

            case 'LOGOUT':
                return initialState;
        
        default:
            return state;
    }
};

// SSO Login using SuiteCRM-issued JWT
export const loginWithSSOToken = (token) => {
    return async (dispatch) => {
        dispatch(loginRequest());

        try {
            const apiBase = process.env.REACT_APP_SUITECRM_BASE_URL; // e.g. http://local.bang.com/
            const ssoUrl = `${apiBase}index.php?entryPoint=ssoLogin&token=${token}`;

            const response = await fetch(ssoUrl);
            const data = await response.json();

            if (data.status === "success") {
                dispatch(loginSuccess(token, null, data));
            } else {
                dispatch(loginFailure(data.message || "SSO login failed"));
            }
        } catch (err) {
            console.error("SSO login error:", err);
            dispatch(loginFailure("An error occurred during SSO login"));
        }
    };
};


export default authReducer;
